import { NSARouterMakerResult } from "namirasoft-account-react";
import { FilterItem, FilterItemOperator, IStorageLocal } from "namirasoft-core";
import { SubscriptionFullRow, SubscriptionItemRow, SubscriptionPaidRow, SubscriptionRow } from "namirasoft-payment";
import { NamirasoftMap } from "namirasoft-site-map";
import { BaseColumnFormatter, DateTimeFormatter, IDFormatter, IntegerFormatter, NSSpace, NSSpaceSizeType, NSTable, NSTitle } from "namirasoft-site-react";
import { useState } from "react";
import { PaymentEntities } from "../PaymentEntities";
import { PaymentLayout } from "../PaymentLayout";
import { PaymentProps } from "../PaymentProps";

export interface SubscriptionViewPageProps extends NSARouterMakerResult, PaymentProps { }

export interface SubscriptionViewPageState
{
    subscription_paids: { rows: SubscriptionPaidRow[], count: number } | null;
}

function SubscriptionViewPage(props: SubscriptionViewPageProps)
{
    let namirasoft = new NamirasoftMap(props.account.token_manager, props.notifier.onError);
    let [state, setState] = useState<SubscriptionViewPageState>({ subscription_paids: null })

    const loadSubscriptionPaids = (offer_id: string) =>
    {
        let filter = new FilterItem(
            namirasoft.payment.tables.subscription_paid,
            namirasoft.payment.tables.subscription_paid.columns.offer_id,
            false,
            FilterItemOperator.all.equals,
            offer_id
        )

        props.servers.payment.subscription_paid.List([filter], null, null, [], null)
            .then((res) => setState((prev) => ({ ...prev, subscription_paids: res })))
            .catch(() => { });
    }

    return (
        <PaymentLayout {...props}
            action={{
                description: "View detailed information about a specific subscription, including its validity period and payment history.",
            }}
            pages={{
                entity: PaymentEntities.Subscription(props),
                view: {
                    ui: {
                        getChildrenAfter: (id: string, row: SubscriptionRow) =>
                        {
                            let e = row as SubscriptionFullRow;
                            loadSubscriptionPaids(row.offer_id)

                            return (
                                <>
                                    {
                                        e.subscription_item.length > 0 &&
                                        <>
                                            <NSSpace size={NSSpaceSizeType.NORMAL} />
                                            <NSTitle title='Items' />
                                            <NSTable<SubscriptionItemRow>
                                                id={id}
                                                name={`subscirption-item`}
                                                checkbox={false}
                                                columns={[
                                                    BaseColumnFormatter.getColumn(namirasoft.payment.tables.subscription_item.columns.sales_item_id, new IDFormatter(namirasoft, new IStorageLocal())),
                                                    BaseColumnFormatter.getColumn(namirasoft.payment.tables.subscription_item.columns.offer_id, new IDFormatter(namirasoft, new IStorageLocal())),
                                                    BaseColumnFormatter.getColumn(namirasoft.payment.tables.subscription_item.columns.offer_item_id, new IDFormatter(namirasoft, new IStorageLocal())),
                                                    BaseColumnFormatter.getColumn(namirasoft.payment.tables.subscription_item.columns.quantity, new IntegerFormatter()),
                                                ]}
                                                getRows={async () =>
                                                {
                                                    return { rows: e.subscription_item, count: e.subscription_item.length };
                                                }}
                                                getRowKey={e => e.value.id.toString()}
                                                ui={{ pagination: false }}
                                                classList={["h-auto"]}
                                            />
                                        </>
                                    }

                                    {
                                        (state.subscription_paids?.rows.length ?? 0) > 0 &&
                                        <>
                                            <NSSpace size={NSSpaceSizeType.NORMAL} />
                                            <NSTitle title="Subscirption Paid History" />
                                            <NSTable<SubscriptionPaidRow>
                                                id={id}
                                                name={`subscirption-paid-history`}
                                                checkbox={false}
                                                columns={[
                                                    BaseColumnFormatter.getColumn(namirasoft.payment.tables.subscription_paid.columns.id, new IDFormatter(namirasoft, null, "50px")),
                                                    BaseColumnFormatter.getColumn(namirasoft.payment.tables.subscription_paid.columns.user_id, new IDFormatter(namirasoft, new IStorageLocal())),
                                                    BaseColumnFormatter.getColumn(namirasoft.payment.tables.subscription_paid.columns.product_id, new IDFormatter(namirasoft, new IStorageLocal())),
                                                    BaseColumnFormatter.getColumn(namirasoft.payment.tables.subscription_paid.columns.invoice_id, new IDFormatter(namirasoft, new IStorageLocal())),
                                                    BaseColumnFormatter.getColumn(namirasoft.payment.tables.subscription_paid.columns.sales_item_id, new IDFormatter(namirasoft, new IStorageLocal())),
                                                    BaseColumnFormatter.getColumn(namirasoft.payment.tables.subscription_paid.columns.offer_id, new IDFormatter(namirasoft, new IStorageLocal())),
                                                    BaseColumnFormatter.getColumn(namirasoft.payment.tables.subscription_paid.columns.applies_at, new DateTimeFormatter()),
                                                    BaseColumnFormatter.getColumn(namirasoft.payment.tables.subscription_paid.columns.expires_at, new DateTimeFormatter()),
                                                    BaseColumnFormatter.getColumn(namirasoft.payment.tables.subscription_paid.columns.created_at, new DateTimeFormatter()),
                                                    BaseColumnFormatter.getColumn(namirasoft.payment.tables.subscription_paid.columns.updated_at, new DateTimeFormatter()),
                                                ]}
                                                getRows={async (page: number, size: number) =>
                                                {
                                                    let filters = [
                                                        new FilterItem(namirasoft.payment.tables.subscription_paid, namirasoft.payment.tables.subscription_paid.columns.offer_id, false, FilterItemOperator.all.equals, row.offer_id)
                                                    ];
                                                    return await props.servers.payment.subscription_paid.List(filters, page, size, [], null);
                                                }}
                                                getRowKey={e => e.value.id.toString()}
                                                classList={["h-auto"]}
                                            />
                                        </>
                                    }
                                </>
                            )
                        }
                    }
                }
            }}
        >
            <></>
        </ PaymentLayout >
    );
}

export default SubscriptionViewPage;